const config = {
  factuursnel_url: process.env.REACT_APP_FACTUURSNEL_URL,
  support_url: process.env.REACT_APP_SUPPORT_URL,
  flagsmith_api: process.env.REACT_APP_FLAGSMITH_API,
  flagsmith_env: process.env.REACT_APP_FLAGSMITH_ENV,
}

export {config}